import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import BlogPostCard from '../components/posts/BlogPostCard'
import { Stack, Pagination } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { useNavigate, useParams } from "react-router-dom";
import useBlogPostService from '../services/blogPostService';
import './posts.css'
import Spinner from 'react-bootstrap/Spinner';
import Sidebar from '../components/Sidebar';

const Posts = () => {
    const { user } = useAuth0();
    const [blogViews, setBlogViews] = useState([]);
    const navigate = useNavigate();
    const { fetchBlogPosts } = useBlogPostService();
    const { type } = useParams();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [isSmOrSmaller, setIsSmOrSmaller] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsSmOrSmaller(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const fetchAndSetBlogViews = async (type) => {
            try {
                const { posts, totalCount } = await fetchBlogPosts(type, currentPage);
                setBlogViews(posts);
                setTotalPages(Math.ceil(totalCount / 10));
            } catch (error) {
                console.error('Error fetching blog posts:', error);
            }
        };
        fetchAndSetBlogViews(type);
    }, [currentPage]);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const userHasAdminRole = () => {
        return user?.['https://gluck.blog/roles']?.includes('BlogAdmin');
    };

    return (
        <div className='mainContainer'>
            <Row >
                {!(isSmOrSmaller && ( type === 'home' || type == 'road')) && (
                    <Col md={3} xs={11} className='side order-xs-1 order-md-2'>
                        <Sidebar />
                    </Col>
                )}

                <Col md={8} xs={10} className='postContainer order-xs-2 order-md-1'>
                    {blogViews.length > 0 ?
                        (<Stack direction="vertical" gap={3}>
                            {blogViews.map((view) => (
                                <BlogPostCard key={view.id} post={view} />
                            ))}
                        </Stack>
                        ) :
                        <Spinner animation="grow" variant="secondary" />

                    }
                </Col>
            </Row>

            {totalPages > 1 && (
                <div className="createButtonContainer">
                    <Pagination>
                        {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                            <Pagination.Item
                                key={page}
                                active={page === currentPage}
                                onClick={() => handlePageChange(page)}
                            >
                                {page}
                            </Pagination.Item>
                        ))}
                    </Pagination>
                </div>
            )}

            <div className='createButtonContainer'>{
                userHasAdminRole() &&
                <Button variant="dark" onClick={() => navigate("/posts/create")}>Create</Button>
            }
            </div>

        </div>
    );
};

export default Posts;